import { SiNaver } from "react-icons/si"; // 네이버 블로그용
import { IoLocationSharp } from "react-icons/io5"; // 지도용
import { IoCall } from "react-icons/io5"; // 전화용
import { FaChevronUp } from "react-icons/fa"; // TOP 버튼용
import './QuickBar.css';

function QuickBar() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="quick-bar">
            {/* 블로그 */}
            <a href="https://blog.naver.com/onpyeong_" target="_blank" rel="noreferrer" className="quick-item" data-info="네이버 블로그 방문">
                <SiNaver className="icon-svg" />
                <small>블로그</small>
            </a>

            {/* 오시는 길 */}
            <a href="/location" className="quick-item" data-info="서울 서초구 서초대로45길 20, 510호">
                <IoLocationSharp className="icon-svg" />
                <small>오시는길</small>
            </a>

            {/* 전화 연결 */}
            <a href="tel:010-4087-0375" className="quick-item" data-info="010-4087-0375">
                <IoCall className="icon-svg" />
                <small>전화상담</small>
            </a>

            {/* TOP 버튼 */}
            <button onClick={scrollToTop} className="quick-item top-btn" data-info="맨 위로 이동">
                <FaChevronUp className="icon-svg" />
                <small>TOP</small>
            </button>
        </div>
    );
}

export default QuickBar;